import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  listItemTextClasses,
  Avatar,
  DialogActions,
  Box,
} from '@mui/material';

export const DialogLinkWhatsappOwnLineContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
    maxWidth: 870,
  },
});

export const DialogLinkWhatsappOwnLineContent = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(5),
    paddingRight: theme.spacing(5),
  }),
);

export const DialogLinkWhatsappOwnLineList = styled(List)({
  padding: 0,
});

export const DialogLinkWhatsappOwnLineListItem = styled(ListItem)(
  ({ theme }) => ({
    padding: 0,
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    alignItems: 'flex-start',

    '&:last-of-type': {
      marginBottom: 0,
    },
  }),
);

export const DialogLinkWhatsappOwnLineListItemAvatar = styled(ListItemAvatar)({
  minWidth: 'auto',
});

export const DialogLinkWhatsappOwnLineAvatar = styled(Avatar)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  height: 30,
  width: 30,
  fontSize: theme.typography.pxToRem(18),
}));

export const DialogLinkWhatsappOwnLineListItemText = styled(ListItemText)(
  ({ theme }) => ({
    [`& .${listItemTextClasses.primary}`]: {
      ...theme.typography.body1,
    },
  }),
);

export const DialogLinkWhatsappOwnLineQRContainer = styled(Box)({
  flexShrink: 0,
  width: 200,
  height: 200,

  '& svg': {
    width: '100%',
    height: '100%',
  },
});

export const DialogLinkWhatsappOwnLineActions = styled(DialogActions)({
  justifyContent: 'flex-end',
});
